export default __webpack_public_path__ + "locales/ro/DowngradePlanDialog.json?hash=df0280585e47b6237b1425b8fb452933";